/** Whole dollars read as the mockup does; cents only when there are some. */
export function formatDollars(cents: number): string {
  const dollars = cents / 100;
  const whole = Number.isInteger(dollars);

  return dollars.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: 2,
  });
}

export const telHref = (phone: string): string => `tel:${phone.replace(/[^\d+]/g, '')}`;
